import { BooleanFilter } from '../Filter/BooleanFilter';
import { CallbackFilter, CallbackFilterType } from '../Filter/CallbackFilter';
import { ContainsFilter } from '../Filter/ContainsFilter';
import { EqualsFilter } from '../Filter/EqualsFilter';
import { FilterInterface, FilterType } from '../Filter/FilterInterface';
import { OneOfFilter, OneOfFilterValueType } from '../Filter/OneOFilter';
import { RangeFilter, RangeFilterValueType } from '../Filter/RangeFilter';
import { ProductInterface } from '../Model/Product';

export class FilterService {
    public static equals<T extends string | number>(
        keyPath: string,
        value: T,
        isActive: boolean = true
    ): FilterInterface<T> {
        return new EqualsFilter(keyPath, value, FilterType.Equals, isActive);
    }

    public static contains<T extends string | number>(
        keyPath: string,
        value: T,
        isActive: boolean = true
    ): FilterInterface<T> {
        return new ContainsFilter(keyPath, value, FilterType.Contains, isActive);
    }

    public static oneOf<T extends OneOfFilterValueType>(
        keyPath: string,
        value: T,
        isActive: boolean = true
    ): FilterInterface<T> {
        return new OneOfFilter(keyPath, value, FilterType.OneOf, isActive);
    }

    public static range<T extends RangeFilterValueType>(
        keyPath: string,
        value: T,
        isActive: boolean = true
    ): FilterInterface<T> {
        return new RangeFilter(keyPath, value, FilterType.Range, isActive);
    }

    public static callback<T>(
        keyPath: string,
        value: T,
        callback: CallbackFilterType<T>,
        isActive: boolean = true
    ): FilterInterface<T> {
        return new CallbackFilter(keyPath, value, FilterType.Callback, isActive, callback);
    }

    public static boolean(keyPath: string, value: boolean, isActive: boolean = true): FilterInterface<boolean> {
        return new BooleanFilter(keyPath, value, FilterType.Equals, isActive);
    }

    public filter<T>(products: ProductInterface[], filters: FilterInterface<T>[]): ProductInterface[] {
        const activeFilters = filters.filter(f => f.isActive);
        let remainingProducts = products;
        let productsCount = products.length;

        for (const filter of activeFilters) {
            remainingProducts = remainingProducts.filter(p => filter.matches(p));
            if (remainingProducts.length < productsCount) {
                console.debug(`[FilterService] Filter ${filter.keyPath} did decrease number of matches from ${productsCount} to ${remainingProducts.length}`);
                productsCount = remainingProducts.length;
            }
        }
        return remainingProducts;
    }
}
